// Must be before main.scss
import Components from "@ui-kit/components"

import "./main.css"

import { runApp } from "@versatile-credit-apply/sdk"

import { i18n } from "./i18n"
import routerSettings from "./router"

import App from "./App.vue"

runApp({
  mode: import.meta.env.MODE === "production" ? "production" : "development",
  root: App,
  api: {
    omniApply: {
      baseUrl: import.meta.env.VITE_APP_APPLY_API_URL,
    },
  },
  router: routerSettings,
  i18n,
  plugins: [Components],
})
